import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const MiscBillPassingView = () => {
  useAuthRedirect();
    const {grnNo} = useParams();
  const branch = localStorage.getItem("branch");
  const [poDetail, setPoDetail] = useState({});
    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false);

  const [subDetails, setSubDetails] = useState({})

          const canView = hasPermission("Bill Passing Menu - Branch", "view");

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/miscBillPassing_detailsHeader?grnNo=${grnNo}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                grnDetail_number: items[0].grnDetail_number,
                grnheader_date: items[0].grnheader_date,
                grnDetail_poNumber: items[0].grnDetail_poNumber,
                grnDetail_poDate: items[0].grnDetail_poDate,
                grnheader_suppliercode: items[0].grnheader_suppliercode,
                grnheader_DcNumber: items[0].grnheader_DcNumber,
                grnheader_DcDate: items[0].grnheader_DcDate,
                grnheader_invoiceNumber: items[0].grnheader_invoiceNumber,
                grnheader_invoiceDate: items[0].grnheader_invoiceDate,
                grnHeader_value: items[0].grnHeader_value || 0,
                grnHeader_discount: items[0].grnHeader_discount || 0,
                grnHeader_pfcharges: items[0].grnHeader_pfcharges || 0,
                grnHeader_freightCharges: items[0].grnHeader_freightCharges || 0,
                grnHeader_paymentTerms: items[0].grnHeader_paymentTerms || "N/A",
                grnHeader_deliveryMethod: items[0].grnHeader_deliveryMethod || "N/A",
                grnHeader_remarks: items[0].grnHeader_remarks || "N/A",
                grnHeader_totalValue: items[0].grnHeader_totalValue || 0,
                grnHeader_CSTtax: items[0].grnHeader_CSTtax || 0,
            };

            setPoDetail(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [grnNo]); 

  useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${poDetail.grnheader_suppliercode}`);
            const items = response.data.supDetails;
            console.log(response.data.supDetails);
            
            const storeReqHeaderCity = {
                supplierMaster_name : items[0].supplierMaster_name || "N/A",
                supplierMaster_addressline1 : items[0].supplierMaster_addressline1 || "N/A",
                supplierMaster_addressline2 : items[0].supplierMaster_addressline2 || "N/A",
                supplierMaster_city : items[0].supplierMaster_city || "N/A",
                supplierMaster_pincode : items[0].supplierMaster_pincode || "N/A",
                
            };
            setSubDetails(storeReqHeaderCity);
            // setData(response.data.supDetails);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchSupplierDetails();
  }, [poDetail.grnheader_suppliercode]); 


const [loading, setLoading] = useState(true);

useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true); // start loading
      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/miscBillPassing_detailsBottom?grnNo=${grnNo}`
      );

      if (response.data && response.data.headerDetails2) {
        setData(response.data.headerDetails2);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    } finally {
      setLoading(false); // stop loading
    }
  };

  fetchData();
}, [grnNo]);

  if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }



  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                              <h2 className="add-txt">Misc Bill Passing GRN View</h2>
                              <Link to='/inventory/miscBillPassingGRNView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                              </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
          <div className="form-row">
              <div className="form-group">
                <label>GRN Number :</label>
                <input type="text" name="PoNumber" value={poDetail.grnDetail_number} readOnly />
              </div>
              <div className="form-group">
                <label>GRN Date :</label>
                <input
  type="text"
  name="endhrs"
  value={poDetail.grnheader_date ? 
         new Date(poDetail.grnheader_date).toLocaleDateString("en-GB") : ""}
  readOnly
/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>P.O Number :</label>
                <input type="text" name="PoNumber" value={poDetail.grnDetail_poNumber} readOnly />
              </div>
              <div className="form-group">
                <label>P.O Date :</label>
                <input
  type="text"
  name="endhrs"
  value={poDetail.grnheader_date ? 
         new Date(poDetail.grnheader_date).toLocaleDateString("en-GB") : ""}
  readOnly
/>

              </div>
            </div>


            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="scode" value={poDetail.grnheader_suppliercode} readOnly/>
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" name="sname" value={subDetails.supplierMaster_name} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>D.C No :</label>
                <input type="text" name="yourRefNo"   value={poDetail.grnheader_DcNumber} readOnly/>
              </div>
              <div className="form-group">
                <label>D.C Date :</label>
                <input
  type="text"
  name="endhrs"
  value={poDetail.grnheader_DcDate ? 
         new Date(poDetail.grnheader_DcDate).toLocaleDateString("en-GB") : ""}
  readOnly
/>

              
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Invoice No :</label>
                <input type="text" name="ourRefNo" value={poDetail.grnheader_invoiceNumber} readOnly />
              </div>
              <div className="form-group">
                <label>Invoice Date :</label>
                <input type="text" name="endhrs"value={poDetail.grnheader_invoiceDate ? new Date(poDetail.grnheader_invoiceDate).toLocaleDateString("en-GB") : ""}readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="address1" value={subDetails.supplierMaster_addressline1} readOnly/>
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input type="text" name="address2" value={subDetails.supplierMaster_addressline2} readOnly/>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="city" value={subDetails.supplierMaster_city} readOnly/>
              </div>
              <div className="form-group">
                <label>Pin Code :</label>
                <input type="text" name="pincode" value={subDetails.supplierMaster_pincode} readOnly/>
              </div>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Qty</th>
                    <th>Accepted Qty</th>
                    <th>Rejected Qty</th>
                    <th>Price</th>
                    <th>GST%</th>
                    <th>PF%</th>
                    <th>Disc%</th>
                    <th>Value</th>
                    <th>Bill Passing By</th>
                  </tr>
                </thead>
              <tbody>
  {loading ? (
    <tr>
      <td colSpan="13" style={{ textAlign: "center", fontWeight: "bold" }}>
        Please wait...
      </td>
    </tr>
  ) : data.length > 0 ? (
    data.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.grnDetail_itemcode}</td>
        <td>{item.grnDetail_itemName}</td>
        <td>{item.grnDetail_uom}</td>
        <td>{item.grnDetail_DcQuantity}</td>
        <td>{item.grnDetail_acceptedQuantity}</td>
        <td>{item.grnDetail_excessShortageQuantity}</td>
        <td>{item.grnDetail_price}</td>
        <td>{item.grnDetail_CSTtax}</td>
        <td>{item.grnDetail_pfPercentage}</td>
        <td>{item.grnDetail_discountPercentage}</td>
        <td>
          {new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(item.grnDetail_acceptedValue || 0)}

        </td>
        <td>{item.GrnDetail_billPassingBy}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="13" style={{ textAlign: "center" }}>
        No items
      </td>
    </tr>
  )}
</tbody>





              </table>
            </div>
                
          </form>
           
        </div>
         {/* Billing Summary */}
      
         <div className="po-bill-container">
                    <h2 className="po-bill-title">Billing Summary</h2>
                    <div className="po-bill-summary">
                    <div className="po-bill-item">
                        <span className="po-bill-label">Sub Total:</span>
                        
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.grnHeader_value)}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">GST (%):</span>
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.grnHeader_CSTtax)}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Disc (%):</span>
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.grnHeader_discount)}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">PF:</span>
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.grnHeader_pfcharges)}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Fright Charges:</span>
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.grnHeader_freightCharges)}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Payment Terms:</span>
                        <span className="po-bill-value">{poDetail.grnHeader_paymentTerms}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Delivery Method:</span>
                        <span className="po-bill-value">{poDetail.grnHeader_deliveryMethod}</span>
                    </div>
                  
                    <div className="po-bill-item">
                        <span className="po-bill-label">Remarks:</span>
                        <span className="po-bill-value">{poDetail.grnHeader_remarks}</span>
                    </div>
                    <div className="po-bill-item po-bill-total">
                        <span className="po-bill-label">Total:</span>
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.grnHeader_totalValue)}</span>
                    </div>

                    </div>
              </div>
      </div>
      
    </div>
  );
};

export default MiscBillPassingView;
